import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import CloseIcon from '~/icons/components/CloseIcon';
import FableticsModal from '~/shared/components/FableticsModal';
import { desktop, useId } from '~/techstyle-shared/react-components';

import ReviewItem from '../ReviewItem';

const Wrapper = styled.div`
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  max-width: min-content;
  max-height: 100vh;

  ${desktop`
    max-height: 90vh;
  `}
`;

const modalDialogStyle = css`
  overflow: hidden;
`;

const blockStyle = css`
  padding: 16px 32px 48px;
`;

const transitionProps = {
  enter: { opacity: 1, transform: 'scale(1, 1)' },
  from: { opacity: 0, transform: 'scale(0.5, 0.5)' },
  leave: { opacity: 0, transform: 'scale(0.5, 0.5)' },
};

const contentWrapperStyles = css`
  display: block;
`;

const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
`;

const ReviewItemPhoto = styled.img`
  display: block;
  overflow: auto;
  max-width: fit-content;
  max-height: 60vh;
  margin: auto;
`;

const ReviewItemModal = ({
  review,
  reviewerNameStyle,
  productInfoStyle,
  reviewStarsStyle,
  dateStyle,
  contentStyle,
  productInfoWrapperStyle,
  showMoreTextProps,
  reviewStarProps,
  isIncentivizedReviewsEnabled,
  closeModal,
  isModalOpen,
}) => {
  const modalId = useId();

  return (
    <FableticsModal
      isOpen={isModalOpen}
      onExit={closeModal}
      dialogStyle={modalDialogStyle}
      overlayClickExits
      contentWrapperStyles={contentWrapperStyles}
      closeButton={<StyledCloseIcon />}
      transitionEnter={transitionProps.enter}
      transitionFrom={transitionProps.from}
      transitionLeave={transitionProps.leave}
      showCloseButton
      titleId={modalId}
      useDefaultFocusTrapConfig
    >
      <Wrapper>
        <div>
          <ReviewItemPhoto src={review.reviewerPhoto} />
        </div>
        <ReviewItem
          review={review}
          blockStyle={blockStyle}
          vertical
          reviewerNameStyle={reviewerNameStyle}
          productInfoStyle={productInfoStyle}
          reviewStarsStyle={reviewStarsStyle}
          dateStyle={dateStyle}
          contentStyle={contentStyle}
          productInfoWrapperStyle={productInfoWrapperStyle}
          showMoreTextProps={showMoreTextProps}
          reviewStarProps={reviewStarProps}
          isIncentivizedReviewsEnabled={isIncentivizedReviewsEnabled}
          isModalItem
        />
      </Wrapper>
    </FableticsModal>
  );
};

ReviewItemModal.propTypes = {
  closeModal: PropTypes.func,
  contentStyle: PropTypes.any,
  dateStyle: PropTypes.any,
  isIncentivizedReviewsEnabled: PropTypes.bool,
  isModalOpen: PropTypes.bool,
  productInfoStyle: PropTypes.any,
  productInfoWrapperStyle: PropTypes.any,
  review: PropTypes.object.isRequired,
  reviewStarProps: PropTypes.object,
  reviewStarsStyle: PropTypes.any,
  reviewerNameStyle: PropTypes.any,
  showMoreTextProps: PropTypes.any,
};

export default ReviewItemModal;
